import React from 'react';
import { Divider } from '@infoods/lifebase-ui';

import { InbodyType } from '../../../../../../../shared/constants/inbody-info/InbodyType';
import { Flags } from '../../../../../../../utils-types';
import { CustomerInfo } from '../../NgzInbodyIndicatorsTab.settings';
import { CustomerParam } from './CustomerParam/CustomerParam';
import { getFeetInchesFromInches } from '../../../../../../../shared/utils/mathUtils/getFeetInchesFromInches/getFeetInchesFromInches';
import classes from './CustomerInfoSection.module.scss';
import { getValueOrDash } from '../../../../../../../shared/utils/stringUtils/getValueOrDash/getValueOrDash';

type CustomerInfoSectionProps = {
  customerInfo: CustomerInfo;
  inbodyTypeFlags: Flags<InbodyType>;
};

const CustomerInfoSection = ({
  customerInfo,
  inbodyTypeFlags,
}: CustomerInfoSectionProps) => {
  const heightValue = customerInfo.height
    ? getFeetInchesFromInches(customerInfo.height).value
    : '—';

  return (
    <div className={classes.container}>
      {!inbodyTypeFlags.NON_INBODY && (
        <>
          <CustomerParam
            title="ID"
            value={getValueOrDash(customerInfo.inbodyId)}
            className="private-info"
          />
          <Divider orientation="vertical" flexItem />
        </>
      )}
      <CustomerParam title="Height" value={heightValue} />
      <Divider orientation="vertical" flexItem />
      <CustomerParam title="Age" value={getValueOrDash(customerInfo.age)} />
      <Divider orientation="vertical" flexItem />
      <CustomerParam title="Gender" value={getValueOrDash(customerInfo.gender)} />
      <Divider orientation="vertical" flexItem />
    </div>
  );
};

export { CustomerInfoSection };
